import {
    TAB_BADGE_ACTIVE_STYLE,
    TAB_BADGE_ZERO_STYLE,
} from '@/components/shared/constants/conditionsBadge';

import { ApplicantSubmissionTrigger } from './ApplicantSubmissions.types';

export const SUBMISSION_TRIGGER_LABELS: Record<ApplicantSubmissionTrigger, string> = {
    // Empty, so the option label leaves it out: only backfilled rows carry it, and "Unknown" read like an error.
    [ApplicantSubmissionTrigger.Unknown]: '',
    [ApplicantSubmissionTrigger.Web]: 'Applicant submit',
    [ApplicantSubmissionTrigger.WebInternalEdit]: 'Internal edit',
    [ApplicantSubmissionTrigger.Highway]: 'Highway',
    [ApplicantSubmissionTrigger.OrpResubmit]: 'ORP resubmit',
    [ApplicantSubmissionTrigger.AutoResubmit]: 'Auto resubmit',
};

// Not a submission id, so it can share the pulldown with them; it stands for the live application.
export const CURRENT_APPLICATION_VALUE = 'current';
// Only when nothing is recorded; otherwise the live application is named after the newest
// submission.
export const CURRENT_APPLICATION_LABEL = 'Current application';
// Ends the live application's label: Last Page Visited, Is Business a Person and the LoadPay link
// status are looked up live, not recorded.
export const LIVE_LOOKUPS_SUFFIX = '(Plus Live Lookups)';
// Replaces the product counts when no Submitted status is linked, as on an unlinked backfill.
export const UNLINKED_SUBMISSION_LABEL = 'Submitted';
// The count is unknown when the list fails, so the badge shows this rather than a misleading 0.
export const SUBMISSIONS_COUNT_UNKNOWN = '?';
export const SUBMISSIONS_COUNT_ERROR_TITLE = 'Submissions could not be loaded';
// The zero-count gray at any count, since submissions need no action, with the active badge's
// black text.
export const SUBMISSIONS_COUNT_STYLE = {
    ...TAB_BADGE_ZERO_STYLE,
    color: TAB_BADGE_ACTIVE_STYLE.color,
} as const;
